import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IBusyOverlayStyles } from "./BusyOverlay.types"

export const BusyOverlayStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IBusyOverlayStyles>
> = (theme: IPartialTheme) => ({
    root: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        display: "flex",
        backgroundColor: `${theme.palette?.white}80`,
        zIndex: 100000
    },
    spinner: {
        flex: 1
    }
})
